<template>
  <v-row justify="center">
    <v-col cols="auto">
      <span
        class="display-1 font-weight-light"
        v-html="`${data.partCount || _.size(data.parts || data.orderItems)} Parts`"
      />
      <span
        class="display-1 font-weight-light"
      >
        -
      </span>
    </v-col>
    <v-col cols="auto">
      <span
        class="display-1 font-weight-light"
      >
        {{ formatCurrency(data.pricing, true) }}
      </span>
    </v-col>
  </v-row>
</template>

<script>
import CurrencyFormatterMixin from '../../../mixins/currencyFormatter';

export default {

  mixins: [
    CurrencyFormatterMixin,
  ],

  props: [
    'data'
  ],
};
</script>
